import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import Drilldown from "highcharts/modules/drilldown";
const chartData = {
  "% of Medicare": [
    { name: "Hospital A", y: 35 },
    { name: "Hospital B", y: 70 },
    { name: "Hospital C", y: 65 },
    { name: "Hospital A", y: 34 },
    { name: "Hospital B", y: 70 },
    { name: "Hospital C", y: 65 },
  ],
  "% Discount": [
    { name: "Hospital A", y: 30 },
    { name: "Hospital B", y: 0 },
    { name: "Hospital C", y: 35 },
    { name: "Hospital A", y: 30 },
    { name: "Hospital B", y: 0 },
    { name: "Hospital C", y: 35 },
  ],
  Completeness: [
    { name: "Network X", y: 230 },
    { name: "Network Y", y: 85 },
    { name: "Network Z", y: 92 },
    { name: "Hospital A", y: 30 },
    { name: "Hospital B", y: 0 },
    { name: "Hospital C", y: 35 },
  ],
};

const DashboardCard = () => {
  const [activeTab, setActiveTab] = useState("% of Medicare");
  const [showStatePopup, setShowStatePopup] = useState(false);
  const [selectedState, setSelectedState] = useState("06");
  const [isHovered, setIsHovered] = useState(false);
  const [draftState, setDraftState] = useState(selectedState);
  const [selectedOption, setSelectedOption] = useState("BUCAs");

  const tabs = ["% of Medicare", "% Discount", "Completeness"];

  return (
    <div>
      <div className="d-flex gap-3">
        <div style={{ width: "35%" }}>
          <div
            className="card bg-light text-center"
            style={{
              height: "190px",
              display: "flex",
              flexDirection: "row",
              flexWrap: "wrap",
              justifyContent: "left",
              // alignItems: "center",
              // height: "175px",
              // padding: " 5px 20px",

              //   backgroundColor: "#F4FAFF ",
              border: "none",
              display: "flex",
              // alignItems: "center",
              boxShadow:
                "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
              display: "flex",
            }}
          >
            <div
              className="card text-center"
              style={{
                display: "flex",
                flexDirection: "row",
                flexWrap: "wrap",
                justifyContent: "left",
                alignItems: "center",
                // height: "175px",
                padding: " 5px 20px",

                // backgroundColor: "#F4FAFF ",
                border: "none",
                display: "flex",

                // boxShadow:
                //   "rgba(0, 0, 0, 0.1) 0px 1px 3px 0px, rgba(0, 0, 0, 0.06) 0px 1px 2px 0px",
                display: "flex",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                  width: "100%",
                }}
              >
                <div className="d-flex flex-row justify-content-between w-100">
                  <h5
                    style={{
                      fontSize: "16px",
                      color: "#3B3A3A",
                      margin: "0px",
                      width: "100%",
                      textAlign: "left",
                    }}
                  >
                    Overall Data Completeness
                  </h5>
                  <p className="m-0">
                    <b style={{ color: "#3B3A3A" }}>93.16%</b>
                  </p>
                </div>

                {/* <p style={{ margin: "0px", textAlign: "left" }}>
                    <span
                      style={{
                        color: "#20486C",
                        fontWeight: "700",
                      }}
                    >
                      Network A &nbsp;
                    </span>
                    has the most data completeness with an index of{" "}
                    <b>97.19%</b>.
                  </p> */}
                {/* Tabs */}

                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    height: "26px",
                    width: "100%",
                    gap: "10px",
                  }}
                >
                  {/* {tabs.map((tab) => (
                    <div
                      key={tab}
                      onClick={() => setActiveTab(tab)}
                      style={{
                        width: "100px",

                        borderRadius: "5px",
                        backgroundColor:
                          activeTab === tab ? "#2E4765" : "white",
                        color: activeTab === tab ? "white" : "#2E4765",
                        fontWeight: "600",
                        fontSize: "12px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border: ".2px dashed #2d4766",
                      }}
                    >
                      {tab}
                    </div>
                  ))} */}
                  {tabs.map((tab) => (
                    <div
                      key={tab}
                      onClick={() => setActiveTab(tab)}
                      style={{
                        width: "100px",

                        borderRadius: "5px",
                        backgroundColor:
                          activeTab === tab ? "#F4FAFF" : "white",
                        color: activeTab === tab ? "#155E9C" : "#4E4E4E",
                        fontWeight: "600",
                        fontSize: "12px",
                        cursor: "pointer",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        border:
                          activeTab === tab ? "none" : ".2px Solid  #D5D5D5",
                      }}
                    >
                      {tab}
                    </div>
                  ))}
                </div>
              </div>

              <div
                style={{
                  marginTop: "10px",
                  width: "100%", // full width
                  maxWidth: "700px", // bigger size for laptops and desktops
                  minWidth: "330px", // minimum size for smaller screens
                  margin: "0 auto", // center the chart
                }}
              >
                <HighchartsReact
                  highcharts={Highcharts}
                  options={{
                    chart: {
                      type: "column",
                      height: 70,
                      backgroundColor: "transparent",
                      spacing: [0, 0, 0, 0], // [top, right, bottom, left] padding
                    },
                    title: { text: null },
                    xAxis: {
                      categories: [
                        "Category A",
                        "Category B",
                        "Category C",
                        "Category D",
                        "Category E",
                        "Category F",
                      ],

                      lineWidth: 2, // thickness of the x-axis line
                      lineColor: "#D6D6D6", // color of the x-axis line
                      labels: {
                        enabled: false,
                        rotation: 0,
                      },
                      tickLength: 0,
                      gridLineWidth: 0,
                    },
                    yAxis: { visible: false },
                    legend: { enabled: false },
                    plotOptions: {
                      series: {
                        borderWidth: 0,
                        dataLabels: { enabled: false },
                        color: "#20486C",
                      },
                    },
                    tooltip: { enabled: true, zIndex: 200 },
                    exporting: { enabled: false },
                    series: [
                      {
                        name: activeTab,
                        data: chartData[activeTab],
                      },
                    ],
                    credits: { enabled: false },
                  }}
                  key={activeTab}
                />
              </div>
            </div>
          </div>
        </div>

        <div
          className="d-flex flex-column justify-content-between"
          style={{ height: "190px", width: "73%" }}
        >
          <div className="d-flex justify-content-between gap-3">
            <div
              style={{
                background: "linear-gradient(45deg, #165A98, #0097D7)",
                padding: "20px",
                color: "white",
                border: "none",
                borderRadius: "7px",
                width: "-webkit-fill-available",
              }}
            >
              <div>
                <b>390M</b>
              </div>
              <div>MRF Record Count</div>
            </div>
            <div
              style={{
                background: "linear-gradient(45deg, #165A98, #0097D7)",
                padding: "20px",
                color: "white",
                border: "none",
                borderRadius: "7px",
                width: "-webkit-fill-available",
              }}
            >
              <div>19</div>
              <div>Total number of Carriers</div>
            </div>
          </div>
          <div className="d-flex justify-content-between gap-3">
            <div
              style={{
                background: "linear-gradient(45deg, #165A98, #0097D7)",
                padding: "20px",
                color: "white",
                border: "none",
                borderRadius: "7px",
                width: "-webkit-fill-available",
              }}
            >
              <div>
                <b>390M</b>
              </div>
              <div>Number of Networks</div>
            </div>
            <div
              style={{
                background: "linear-gradient(45deg, #165A98, #0097D7)",
                padding: "20px",
                color: "white",
                border: "none",
                borderRadius: "7px",
                width: "-webkit-fill-available",
              }}
            >
              <div>607K</div>
              <div>Billing NPI Count</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardCard;
